<template>
  <el-tooltip
      :content="dictionaryTypeName"
      :placement="tooltipPlacement"
      :disabled="tooltipDisabled"
      :open-delay="500">
    <v-icon :color="dictionaryTypeColor" :small="small">icon-{{ type }}-dictionary</v-icon>
  </el-tooltip>
</template>

<script>
import {DICTIONARY_TYPE_COLORS, DICTIONARY_TYPE_NAMES} from "@/constants";

export default {
  name: "DictionaryIcon",
  props: {
    type: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    tooltipPlacement: {
      type: String,
      default: 'left',
    },
    tooltipDisabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    dictionaryTypeName() {
      return DICTIONARY_TYPE_NAMES[this.type];
    },
    dictionaryTypeColor() {
      return DICTIONARY_TYPE_COLORS[this.type];
    },
  },
}
</script>

<style scoped>

</style>
